import React from "react"

const smoothScrollContext = React.createContext()

export default smoothScrollContext
